export const SEND_REMINDERS_REQUEST="REMINDERS/SEND_REMINDERS_REQUEST";
export const SEND_REMINDERS_SUCCESS="REMINDERS/SEND_REMINDERS_SUCCESS";
export const SEND_REMINDERS_FAILURE="REMINDERS/SEND_REMINDERS_FAILURE";